import { Frequency } from '../practice/preference';

export interface ExerciseRoutine {
  daysPerWeek?: number;
  durationMinutes?: number;
}

export enum TobaccoStatus {
  Never = 'NEVER',
  Former = 'FORMER',
  Somedays = 'SOME_DAYS',
  Everyday = 'EVERY_DAY',
  Light = 'LIGHT',
  Heavy = 'HEAVY',
  Unknown = 'UNKNOWN',
  Other = 'OTHER',
}

export enum TobaccoAmount {
  QuarterPack = 'QUARTER_PACK',
  HalfPack = 'HALF_PACK',
  OnePack = 'ONE_PACK',
  TwoPacks = 'TWO_PACKS',
  ThreePacks = 'THREE_PACKS',
  MoreThanThreePacks = 'MORE_THAN_THREE_PACKS',
  Unknown = 'UNKNOWN',
  Other = 'OTHER',
}

export enum TobaccoTreatment {
  Counseling = 'COUNSELING',
  Hypnosis = 'HYPNOSIS',
  Medications = 'MEDICATIONS',
  NicotineReplacement = 'NICOTINE_REPLACEMENT',
  None = 'NONE_OF_THE_ABOVE',
  Other = 'OTHER',
}

export interface TobaccoUsage {
  status: TobaccoStatus;
  statusRaw?: string;
  amount?: TobaccoAmount;
  amountRaw?: string;
  yearsOfUsage?: number;
  comment?: string;
  previousTreatments?: TobaccoTreatment[];
  previousTreatmentsRaw?: string[];
}

export enum AlcoholUsageStatus {
  CurrentlyUse = 'CURRENTLY_USE',
  NeverUsed = 'NEVER_USED',
  FormerlyUsed = 'FORMERLY_USED',
  NotSincePregnant = 'NOT_SINCE_PREGNANT',
  InEarlyPregnancy = 'IN_EARLY_PREGNANCY',
  InRecovery = 'IN_RECOVERY',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  UnableToObtain = 'UNABLE_TO_OBTAIN',
  Other = 'OTHER',
}

export interface AlcoholUsage {
  status: AlcoholUsageStatus;
  frequency?: Frequency;
  quantity?: number;
  concernsAtHome?: boolean;
}

export enum Contraceptive {
  Abstinence = 'ABSTINENCE',
  BirthControlPill = 'BIRTH_CONTROL_PILL',
  Condom = 'CONDOM',
  FemaleSterilization = 'TUBAL_LIGATION',
  HormoneShot = 'HORMONE_SHOT',
  Hysterectomy = 'HYSTERECTOMY',
  Iud = 'IUD',
  MaleSterilization = 'VASECTOMY',
  NaturalPlanning = 'NATURAL_PLANNING',
  NoContraceptive = 'NONE',
  Other = 'OTHER',
  Patch = 'THE_PATCH',
  PlanB = 'PLAN_B',
  PostMenopausal = 'POST_MENOPAUSAL',
  PullOutMethod = 'PULL_OUT_METHOD',
  Ring = 'VAGINAL_RING',
  VaginalInsert = 'VAGINAL_INSERT',
}

export interface SexualHealth {
  active: boolean;
  contraceptives?: Contraceptive[] | null;
  orientation: SexualOrientation | null;
}

export enum SexualPronoun {
  SheHer = 'SHE_HER',
  HeHim = 'HE_HIM',
  TheyTheir = 'THEY_THEIR',
  Other = 'OTHER',
}

export enum SexualIdentity {
  Female = 'FEMALE',
  Male = 'MALE',
  FemaleToMaleTransMan = 'TRANS_MAN',
  MaleToFemaleTransWoman = 'TRANS_WOMAN',
  Genderqueer = 'GENDERQUEER',
  Other = 'OTHER',
  NonDisclosure = 'CHOOSE_NOT_TO_DISCLOSE',
}

export enum SexAtBirth {
  Female = 'FEMALE',
  Male = 'MALE',
  Intersex = 'INTERSEX',
  NonDisclosure = 'CHOOSE_NOT_TO_DISCLOSE',
  Other = 'OTHER',
}

export enum SexualOrientation {
  Homosexual = 'HOMOSEXUAL',
  Heterosexual = 'HETEROSEXUAL',
  Bisexual = 'BISEXUAL',
  DontKnow = 'DONT_KNOW',
  ChooseNotToDisclose = 'CHOOSE_NOT_TO_DISCLOSE',
  Other = 'OTHER',
}

export interface SexualOrientationFieldValue {
  orientation?: SexualOrientation | null;
  orientationRaw?: string | null;
}

export interface GenderIdentityFieldValue {
  identity?: SexualIdentity | null;
  identityRaw?: string | null;
}

export interface SexualIdentityFieldValue
  extends SexualOrientationFieldValue,
    GenderIdentityFieldValue {
  pronouns?: SexualPronoun | null;
  pronounsRaw?: string | null;
  sexAtBirth?: SexAtBirth | null;
  sexAtBirthRaw?: string | null;
}
